import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import {customisedIntlFormatMessage} from '../../utils/helpers';

import style from './ResultsSetSort.scss';

const messages = defineMessages({
  resultsSetSortLabelPrograms: {
    id: 'resultsSetSort.LabelPrograms',
    defaultMessage: `Sort {count} programs by:`,
    description: 'school programs sort label',
    values: {
      count: 1,
    },
  },
  resultsSetSortLabelSchools: {
    id: 'resultsSetSort.LabelSchools',
    defaultMessage: `Sort {count} schools by:`,
    description: 'school schools sort label',
    values: {
      count: 1,
    },
  },
  resultsSetSortDistance: {
    id: 'resultsSetSort.Distance',
    defaultMessage: 'Distance',
    description: 'school sort distance',
  },
  resultsSetSortDistanceLong: {
    id: 'resultsSetSort.DistanceLong',
    defaultMessage: 'Sort by distance',
    description: 'school sort distance long',
  },
  resultsSetSortRecentlySaved: {
    id: 'resultsSetSort.RecentlyAdded',
    defaultMessage: 'Recently added to favorites',
    description: 'school sort recently added',
  },
  resultsSetSortRecentlySavedLong: {
    id: 'resultsSetSort.RecentlyAddedLong',
    defaultMessage: 'Sort by recently added',
    description: 'school sort recently added long',
  },
});

class ResultsSetSort extends Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    onSort: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['programs', 'schools']).isRequired,
    intl: PropTypes.shape().isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      active: 'savedAt',
      sortByDirection: 'highToLow',
    };
  }

  handleOnSort = ({ sortBy, sortByDirection }) => {
    const { onSort } = this.props;

    this.setState({
      ...this.state,
      active: sortBy,
      sortByDirection,
    });

    onSort({ sortBy, sortByDirection });
  };

  render() {
    const { count, type, intl } = this.props;
    const { active } = this.state;

    const distanceButtonClasses = [style.button];
    const savedAtButtonClasses = [style.button];
    if (active === 'distance') {
      distanceButtonClasses.push(style.buttonActive);
    } else if (active === 'savedAt') {
      savedAtButtonClasses.push(style.buttonActive);
    }

    return (
      <div className={style.root} data-coachmark="saved-step-3">
        <h2 className={style.label}>
          {type === 'programs' ? (
            <FormattedMessage {...messages.resultsSetSortLabelPrograms} values={{ count }} />
          ) : (
            <FormattedMessage {...messages.resultsSetSortLabelSchools} values={{ count }} />
          )}
        </h2>
        <div className={style.buttonsWrapper}>
          <button
            className={classNames(...distanceButtonClasses)}
            onClick={() => this.handleOnSort({ sortBy: 'distance', sortByDirection: 'lowToHigh' })}
            aria-pressed={active === 'distance'}
            aria-label={customisedIntlFormatMessage(intl, messages.resultsSetSortDistanceLong)}
          >
            <FormattedMessage {...messages.resultsSetSortDistance} />
          </button>
          <button
            className={classNames(...savedAtButtonClasses)}
            onClick={() => this.handleOnSort({ sortBy: 'savedAt', sortByDirection: 'highToLow' })}
            aria-pressed={active === 'savedAt'}
            aria-label={customisedIntlFormatMessage(intl, messages.resultsSetSortRecentlySavedLong)}
          >
            <FormattedMessage {...messages.resultsSetSortRecentlySaved} />
          </button>
        </div>
      </div>
    );
  }
}

export default withStyles(style)(injectIntl(ResultsSetSort));
